import styled from 'styled-components';
import { colors } from 'components/Theme';

export default styled.li`
  display: table;
  padding-bottom: 1px;
  margin-bottom: 0.6em;
  font-size: 1em;
  font-weight: 300;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  list-style-type: none;

  &:hover a {
    text-decoration: underline;
  }

  a {
    color: ${colors.blueGrey.c500} !important;
  }

  cursor: pointer;
  padding-left: 1rem;

  &.library-nav-item--active {
    a {
      font-weight: 700;
      text-decoration: underline;
    }
  }

  &.library-nav-item--default {
    border-bottom: none;
  }

  &.library-nav-item--headline {
    font-weight: 400;
    box-shadow: inset 0 -2px 0 0 ${colors.grey.c500};
    border-bottom: none;
  }

  &.library-nav-item--top {
    margin-bottom: 0 !important;
  }

  @include media-breakpoint-up(md) {
    padding-left: 2.7rem;
  }
  @include media-breakpoint-up(lg) {
    padding-left: 1.3rem;
  }
`;
